export default __webpack_public_path__ + "static/media/unnamed_updown_arrow.d44d025e.svg";